import * as React from 'react'

// types
import { EmitOptions } from '../types'

// blocks
import useEmitSave from './useEmitSave'


export default function useStreamActions() {

  // hooks
  const emitSave = useEmitSave()

  const cls = new class {

    get player() {
      return typeof window !== 'undefined' && window.player ? window.player : null
    }

    play() {
      this.player.stream.play()
    }

    reconnect() {
      this.player.stream.reconnect()
    }

    emitUi(payload: object, options?: EmitOptions) {
      window.emitUIInteraction(payload)
      emitSave.save('ui', payload, options)
    }

    emitSys(payload: object, options?: EmitOptions) {
      window.emitCommand(payload)
      emitSave.save('sys', payload, options)
    }

    resetResolution() {
      const width = window.innerWidth || document.documentElement.clientWidth
        || document.body.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight
        || document.body.clientHeight;

      const payload = ({ 'Resolution.Width': width, 'Resolution.Height': height })
      this.emitSys(payload, { debug: false })
    }
  }

  return cls

}

